module.exports = __webpack_public_path__ + "media/images/client/favicons/apple-touch-icon-76x76-b7bf41e81091aa0616f52aa189dd30d8.png";